import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import ApiKeyPage from './pages/ApiKeyPages/ApiKeyPage'
import ConsentPage from './pages/ConsentPage/ConsentPage';
import HomePage from './pages/HomePage/HomePage'; 
import DirectRenderPage from './pages/DirectRenderPage/DirectRenderPage';
import SessionKeyPage from './pages/ApiKeyPages/SessionKeyPage';
// import SubscriptionForm from './pages/SurveyPages/SubscriptionForm';
import SurveyPage from './pages/SurveyPages/SurveyPage';
import surveyJson from './constants/survey.json'; // Import here
import InfoPage from './pages/InfoPage/InfoPage';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import reducer from './store/reducers';

const store = createStore(reducer, applyMiddleware(thunk));

const App = () => {
  return (
    <React.StrictMode>
      <Provider store={store}>
      <BrowserRouter basename='/pubserv/BPMN-Chatbot-Beta'>
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<ProtectedRoute><HomePage/></ProtectedRoute>}/>
          <Route path="/direct-render" element={<ProtectedRoute><DirectRenderPage/></ProtectedRoute>}/>
          <Route path="/consent" element={<ConsentPage />} />
          <Route path="/survey" element={<SurveyPage surveyJson={surveyJson} />} />
          <Route path="/enterapikey" element={<ApiKeyPage />} />
          <Route path="/session/:sessionKey" element={<SessionKeyPage />} />
          <Route path="*" element={<Navigate to="/home" />} />
          <Route path="/info" element={<InfoPage />} />
        </Routes>
      </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(<App/>);
